module.exports = __webpack_public_path__ + "media/images/default/pages/public_sciences/Frame177-409696bfdf59219ef3cfb01cdc9b7750.png";